import r from "../../shared-lib/braze-shared-lib.js";
import FeatureFlag from "./feature-flag.js";
export function newFeatureFlagFromJson(e) {
  if (e[FeatureFlag.Tt.ns] && "boolean" == typeof e[FeatureFlag.Tt.Fe])
    return new FeatureFlag(
      e[FeatureFlag.Tt.ns],
      e[FeatureFlag.Tt.Fe],
      e[FeatureFlag.Tt.we],
      e[FeatureFlag.Tt.ze],
    );
  r.j.info(`Unable to create feature flag from ${JSON.stringify(e, null, 2)}`);
}
export function newFeatureFlagFromSerializedValue(e) {
  if (e[FeatureFlag.hs.ns] && "boolean" == typeof e[FeatureFlag.hs.Fe])
    return new FeatureFlag(
      e[FeatureFlag.hs.ns],
      e[FeatureFlag.hs.Fe],
      e[FeatureFlag.hs.we],
      e[FeatureFlag.hs.ze],
    );
  r.j.info(
    `Unable to deserialize feature flag from ${JSON.stringify(e, null, 2)}`,
  );
}
